import React, { useEffect } from 'react'
import T from 'prop-types'
import Container from 'components/Container'
import Editorial from 'components/Editorial'
import Details from 'components/Details'
import Button from 'components/Button'
import useSession from 'hooks/useSession'
import { getJSON, removeItem } from 'lib/storage'
import Header from 'apps/booking/components/Header'

import ConfirmationHeader from '../components/ConfirmationHeader'

export default function WaitingList({
  match: {
    params: { orgUnit },
  },
}) {
  // Get userdata
  const bookingState = getJSON('bookingState') || {}

  // Flush the session storage to prevent user from going back and getting confused
  useEffect(() => {
    removeItem('bookingState')
  }, [])

  // Get stored data
  const { orgUnitTitle, decidedPriority } = bookingState

  // Get name
  const { session, clearSession } = useSession()
  const { first_name, last_name } = session || {}
  const fullName = `${first_name} ${last_name}`

  // Generate title based on priority
  let title = 'Du er plassert i kandidatlisten'
  if (decidedPriority < 10) {
    title = `Du er plassert i kandidatlisten\u00A0 (risikogruppe ${decidedPriority})`
  }

  // Show error if missing booking state
  if (!orgUnitTitle || decidedPriority === undefined || decidedPriority === null) {
    return (
      <>
        <Header />
        <Container size="tight">
          <h1>Det skjedde en feil</h1>
          <p>
            Vi klarer ikke vise deg en bekreftelse for registreringen da det har skjedd en feil.
            Vennligst prøv igjen.
          </p>
          <Button arrow to={`/${orgUnit}`}>
            Bestill ny time
          </Button>
        </Container>
      </>
    )
  }

  return (
    <>
      <Header seoTitle="Takk for din registering" />

      <Container size="wizard" style={{ paddingBottom: '3rem' }}>
        <ConfirmationHeader title={title} />
        <Details
          type="box"
          data={[
            {
              id: 'time',
              icon: 'time',
              value: 'Følg med på informasjon fra kommunen om når din gruppe skal vaksineres',
            },
            {
              id: 'place',
              icon: 'place',
              value: `Du er registrert i ${orgUnitTitle}`,
            },
            {
              id: 'who',
              icon: 'user',
              value: fullName,
            },
          ]}
        />

        <Editorial>
          <p>
            Noen kommuner gir direkte beskjed til de som kan bestille seg time. Andre går ut med
            informasjon via media og internett når bestilling åpnes. Undersøk med din kommune om
            hvordan det gjøres der du bor.
          </p>
        </Editorial>

        <Button onClick={() => clearSession(`/${orgUnit}`)} primary>
          Avslutt og logg ut
        </Button>
      </Container>
    </>
  )
}

WaitingList.propTypes = {
  match: T.shape({
    params: T.shape({
      orgUnit: T.string.isRequired,
    }).isRequired,
  }).isRequired,
}
